import { FC, useCallback, useState } from "react";
import styles from "./styles.module.scss";
import { Toast } from '@douyinfe/semi-ui';
import useRequest from "@/utils/useRequest";
import { useTranslations } from "next-intl";
import { useRouter } from "next/router";
export interface IFooterProps {

}

export const Footer: FC<IFooterProps> = ({

}) => {
  const request = useRequest()
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: ''
  })
  const router = useRouter()
  const t = useTranslations();

  const onChage = useCallback((e: any, type: 'name' | 'email' | 'company') => {
    const data = { ...formData }
    data[type] = e.target.value
    setFormData(data)
  }, [formData])

  const btnClick = useCallback(async () => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!formData.name && !formData.email && formData.company) {
      Toast.error({
        content: t('home.tips.all'),
        duration: 3,
      })
      return
    }
    if (!regex.test(formData.email)) {
      Toast.error({
        content: t('home.tips.email'),
        duration: 3,
      })
      return
    }
    const { data } = await request.post('/addSubscribe', {
      truename: formData.name,
      email: formData.email,
      company: formData.company
    })
    if (data.code === 200) {
      Toast.success({
        content: data?.msg,
        duration: 3,
      })
    } else {
      Toast.error({
        content: data?.msg,
        duration: 3,
      })
    }

    if (data?.code) {
      setFormData({
        name: '',
        email: '',
        company: ''
      })
      // window.scrollTo(0, 0)
    }

  }, [formData])

  return (
    <div className={styles.footer}>
      <div className={styles.subscribe}>
        <i></i>
        <p>{t('common.subscribe1')}<br className="minHidden" />{t('common.getNew')}</p>
        <div className={styles.form}>
          <input type="text" placeholder={t('common.placeholder.company')} value={formData.company}
            onChange={(e) => onChage(e, 'company')} />
          <i></i>
          <input type="text" placeholder={t('common.placeholder.name')} value={formData.name}
            onChange={(e) => onChage(e, 'name')} />
          <i></i>
          <input type="text" placeholder={t('common.placeholder.email')} value={formData.email}
            onChange={(e) => onChage(e, 'email')} />
          <button onClick={btnClick}>{t('common.subscribe')}</button>
        </div>
      </div>
      <div className={styles.info}>
        <div className={styles.top}>
          <img onError={(e: any) => e.target.src = 'http://admin.ipbexpo.com/uploads/editor/20250421/1d158468348e36f262393b6ff2b0d00e.jpg'} src="/image/footer-logo.png" alt="" />
          <div>
            <div className={styles.left}>
              <p className={styles.time}>{t('common.time')}</p>
              <p className={styles.site}>{t('common.site')}{router.locale === 'en' && <br />}{t('common.location')}</p>
            </div>
            <div className={styles.center}>
              <div>
                <p className={styles.unit}>{t('common.organizers')}：{t('common.organizer1')}</p>
                <p className={styles.phone}>{t('common.telephone')}：021-6036 1225</p>
                <p className={styles.email}>{t('common.email')}：ipb@nm-china.com.cn</p>
                <p className={styles.address}>
                  {t('common.companySite')}：{t('common.companySite1')}</p>
              </div>
              <div>
                <p className={styles.unit}>{t('common.organizers')}：{t('common.organizer2')}</p>
                <p className={styles.phone}>{t('common.telephone')}：010-62647647/62647657</p>
                <p className={styles.email}>{t('common.email')}：klxh@ipe.ac.cn</p>
                <p className={styles.address}>{t('common.companySite')}{t('common.companySite2')}</p>
              </div>
            </div>
            <div className={styles.right}>
              <p>{t('common.attention')}</p>
              <div>
                <div>
                  <img onError={(e: any) => e.target.src = 'http://admin.ipbexpo.com/uploads/editor/20250421/1d158468348e36f262393b6ff2b0d00e.jpg'} src="/image/wxcode.png" alt="" />
                  <p>{t('common.wxOfficial')}</p>
                </div>
                <div>
                  <img onError={(e: any) => e.target.src = 'http://admin.ipbexpo.com/uploads/editor/20250421/1d158468348e36f262393b6ff2b0d00e.jpg'} style={{ padding: '10px' }} src="/image/video-code.png" alt="" />
                  <p>{t('common.wxVideo')}</p>
                </div>
              </div>

            </div>
          </div>

        </div>
        <div className={styles.bottom}>
          <p>
            {t('common.organizers')}
            <img onError={(e: any) => e.target.src = 'http://admin.ipbexpo.com/uploads/editor/20250421/1d158468348e36f262393b6ff2b0d00e.jpg'} src="/image/sponsor1.png?date=202509081541" alt="" />
            <img onError={(e: any) => e.target.src = 'http://admin.ipbexpo.com/uploads/editor/20250421/1d158468348e36f262393b6ff2b0d00e.jpg'} src="/image/sponsor2.png?date=202509081541" alt="" />
          </p>
          <p>
            {t('common.powered')}
            <img onError={(e: any) => e.target.src = 'http://admin.ipbexpo.com/uploads/editor/20250421/1d158468348e36f262393b6ff2b0d00e.jpg'} src="/image/sponsor3.png" alt="" />
          </p>
          <p>
            {t('common.supported1')}
            <img onError={(e: any) => e.target.src = 'http://admin.ipbexpo.com/uploads/editor/20250421/1d158468348e36f262393b6ff2b0d00e.jpg'} src="/image/sponsor4.png" alt="" />
          </p>
          <p>
            {t('common.supported2')}
            <img onError={(e: any) => e.target.src = 'http://admin.ipbexpo.com/uploads/editor/20250421/1d158468348e36f262393b6ff2b0d00e.jpg'} src="/image/sponsor5.png" alt="" />
          </p>
        </div>
      </div>
      <div className={styles.copyright}>
        <p>纽伦堡会展(上海)有限公司 版权所有<a target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index"> © 2025 沪ICP备09011147号-16</a></p>
      </div>
    </div>
  );
};
